/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spare_Ago_Dove_BaskInputs */

const fr_spare_ago_dove_bask = /** @type {(inputs: Spare_Ago_Dove_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau mot de passe`)
};

/**

* @param {Spare_Ago_Dove_BaskInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spare_ago_dove_bask = /** @type {((inputs?: Spare_Ago_Dove_BaskInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spare_Ago_Dove_BaskInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spare_ago_dove_bask(inputs)
});